export default {
  name: 'documentUploadItem',

  props: {
    name: {
      type: String,
      required: true
    },

    id: {
      type: String,
      required: true
    },

    canBeDeleted: {
      type: Boolean,
      required: true
    }
  },

  methods: {
    handleDownloadClick() {
      this.$emit('onDownloadClick', {
        documentId: this.id,
        documentName: this.name
      })
    },

    handleDeleteClick() { this.$emit('onDeleteClick', this.id) }
  }
}
